import { datadogLogs } from '@datadog/browser-logs';
import { LogType } from '../types/logType';

export class DatadogLogger {
  private static initialized = false;

  static Initialize(
    clientToken: string,
    site: string,
    service: string,
    env: string,
  ): void {
    if (DatadogLogger.initialized) return;
    datadogLogs.init({
      clientToken,
      site,
      service,
      env,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    });
    DatadogLogger.initialized = true;
  }

  static Log(message: string, context: object, type: LogType): void {
    if (!DatadogLogger.initialized) return;
    switch (type) {
      case LogType.ERROR:
        datadogLogs.logger.error(message, context);
        break;
      case LogType.WARN:
        datadogLogs.logger.warn(message, context);
        break;
      case LogType.DEBUG:
        datadogLogs.logger.debug(message, context);
        break;
      default:
        datadogLogs.logger.info(message, context);
    }
  }
}
